export { default } from './SimpleProductsListHeader';
